import { render, staticRenderFns } from "./OrganizationLayout.vue?vue&type=template&id=a57cfe38"
import script from "./OrganizationLayout.vue?vue&type=script&lang=js"
export * from "./OrganizationLayout.vue?vue&type=script&lang=js"
import style0 from "./OrganizationLayout.vue?vue&type=style&index=0&id=a57cfe38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports